<ng-container [ngSwitch]="mode">

  <ng-container *ngSwitchCase="'vr'">
    <div class="p-d-flex p-ai-center p-jc-end p-flex-column toolbar">
      <div class="p-mb-2" *ngIf="form === 'normal'">
        <img class="icon" alt=""
             src="assets/images/call.svg"
             (click)="showPhoneNumberDialog()">
      </div>
      <div class="p-mb-2">
        <div class="p-d-flex p-flex-column">
          <div class="p-mb-1" (click)="$event.stopPropagation(); toggleLike()">
            <ng-container *ngIf="inFavourites === false || !inFavourites">
              <img class="icon favorite" src="assets/images/favorite.svg" alt="">
            </ng-container>
            <ng-container *ngIf="inFavourites === true">
              <img class="icon favorite" src="assets/images/favorite-active.svg" alt="">
            </ng-container>
          </div>
          <div class="desktop">{{likesCount > 99 ? '99+' : likesCount}}</div>
        </div>
      </div>
      <div class="p-mb-2"  *ngIf="form === 'normal'">
        <app-real-property-details-link
          [id]="applicationId"
          [queryParams]="{ tab: 'comments' }">
          <div class="p-d-flex p-flex-column">
            <div class="p-mb-1">
              <img class="icon" src="assets/images/comment.svg" alt="">
            </div>
            <div>
              {{commentsCount > 99 ? '99+' : commentsCount}}
            </div>
          </div>
        </app-real-property-details-link>
      </div>
      <div  *ngIf="form === 'normal'">
        <img class="icon" src="assets/images/contribution.svg" alt="">
      </div>
    </div>
  </ng-container>
  
  <ng-container *ngSwitchCase="'hr'">
    <div class="p-d-flex p-jc-around p-mt-2 p-mb-2 btn-action-body">
      <div class="p-d-flex p-center action-block btn like" (click)="toggleLike()">
        <ng-container *ngIf="inFavourites">
          <img class="icon" src="assets/images/favorite-active.svg" alt="">
        </ng-container>
        <ng-container *ngIf="!inFavourites">
          <img class="icon desktop" src="assets/images/favorite.svg" alt="">
          <img class="icon mobile" src="assets/images/mobile-favorite.svg" alt="">
        </ng-container>
        <span class="like-count">{{likesCount > 99 ? '99+' : likesCount}}</span>
      </div>
      <div class="p-d-md-flex p-d-none p-center action-block btn comment">
        <img class="icon" src="assets/images/comment.svg" alt="">
        <span>{{commentsCount > 99 ? '99+' : commentsCount}}</span>
      </div>
      <div (click)="shareHandler()" class="p-d-flex p-center action-block btn like share">
        <img class="icon" src="assets/images/share-detail.svg" alt="">
      </div>
    </div>
  </ng-container>
  
</ng-container>
